import React from "react";

import { cn } from "@/styles/cn";

export const ThCell = React.forwardRef<
  HTMLTableCellElement,
  React.ThHTMLAttributes<HTMLTableCellElement>
>(({ className, ...props }, ref) => (
  <th
    ref={ref}
    className={cn(
      "bg-rdc-primaryLight font-bold uppercase text-rdc-primary",
      "p-2 px-5 text-left text-[0.625rem] leading-[0.73125rem]",
      "first:rounded-tl-lg last:rounded-tr-lg",

      className,
    )}
    {...props}
  />
));

ThCell.displayName = "TableHeaderCell";

export const TdCell = React.forwardRef<
  HTMLTableCellElement,
  React.ThHTMLAttributes<HTMLTableCellElement> & { showGridlines?: boolean }
>(({ className, showGridlines, ...props }, ref) => (
  <td
    ref={ref}
    className={cn(
      "h-[3rem] border-y border-rdc-border p-2 px-5 text-left align-middle text-sm font-normal text-rdc-gray first:border-l last:border-r",
      { border: showGridlines },
      className,
    )}
    {...props}
  />
));

TdCell.displayName = "TableRowCell";

/***
 * table ligth
 */
export const TableLight = React.forwardRef<
  HTMLTableElement,
  React.TableHTMLAttributes<HTMLTableElement>
>(({ className, ...props }, ref) => (
  <table ref={ref} className={cn("w-full", className)} {...props} />
));

TableLight.displayName = "TableLight";
